import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { HomePage } from '../pages/home/HomePage';

const AdminPage = lazy(() => import('../pages/admin/AdminPage'));

export function App() {
  return (
    <Routes>
      <Route
        path="/admin"
        element={
          <Suspense fallback={null}>
            <AdminPage />
          </Suspense>
        }
      />
      <Route path="*" element={<HomePage />} />
    </Routes>
  );
}
